import { render, staticRenderFns } from "./ShopComponent.vue?vue&type=template&id=065b0176&scoped=true"
import script from "./ShopComponent.vue?vue&type=script&lang=js"
export * from "./ShopComponent.vue?vue&type=script&lang=js"
import style0 from "./ShopComponent.vue?vue&type=style&index=0&id=065b0176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065b0176",
  null
  
)

export default component.exports